import { Article } from './Article/types';
import NextContents from '@/assets/img/ico_next_contents@2x.png';
import PrevContents from '@/assets/img/ico_prev_contents@2x.png';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { Link } from 'gatsby';
import React, { FC } from 'react';
import styled from 'styled-components';

interface BoardPrevNextProps {
  prev?: PrevNextArticle;
  next?: PrevNextArticle;
  baseUri: string;
  queryString: string;
}

export type PrevNextArticle = Pick<
  Article,
  'boardIndexNumber' | 'subject' | 'firstRegisterDate'
>;

const List = styled.div`
  border-top: 1px solid #e5e6e8;

  & > dl {
    display: flex;
    border-bottom: 1px solid #e5e6e8;
    padding: 20px 0;
    align-items: center;

    dt {
      width: 90px;
      padding-left: 8px;

      strong {
        display: inline-block;
        padding-left: 40px;
        position: relative;

        &::before {
          content: '';
          display: block;
          width: 24px;
          height: 24px;
          background-size: cover;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translate(0, -50%);
        }
        &.next {
          &::before {
            background: url(${NextContents}) no-repeat center center;
            background-size: 100%;
          }
        }
        &.prev {
          &::before {
            background: url(${PrevContents}) no-repeat center center;
            background-size: 100%;
          }
        }
      }
    }

    dd {
      width: calc(100% - 90px);
      color: #828385;
      font-size: 14px;
      padding-left: 24px;
      display: flex;
      align-items: center;

      .date {
        width: 70px;
        color: #828385;
        font-size: 14px;
        ${breakpoint(`mobile`)} {
          // 공지사항, 보도자료 해당됨.
          // TODO : 다른곳도 동일한지 확인필요.
          display: none;
        }
      }
    }
  }
`;

const LinkItem = styled(Link)`
  width: calc(100% - 70px);
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  color: #2d2926;
  line-height: 2;
  letter-spacing: -0.8px;
  ${breakpoint(`mobile`)} {
    // 공지사항, 보도자료 해당됨.
    width: 100%;
  }
`;

const BoardPrevNext: FC<BoardPrevNextProps> = ({
  prev,
  next,
  baseUri,
  queryString,
}) => (
  <List>
    <dl>
      <dt>
        <strong className="prev">이전글</strong>
      </dt>
      {prev && prev.boardIndexNumber !== null ? (
        <dd>
          <LinkItem
            to={`${baseUri}/${prev.boardIndexNumber}${queryString}`}
            state={{ boardCategoryCode: prev.boardCategoryCode }}
          >
            {prev.subject}
          </LinkItem>
          <p className="date">
            {/* {dayjs(prev.firstRegisterDate).format(`YYYY.MM.DD`)} */}
            {prev.firstRegisterDate}
          </p>
        </dd>
      ) : (
        <dd>이전글이 존재하지 않습니다.</dd>
      )}
    </dl>
    <dl>
      <dt>
        <strong className="next">다음글</strong>
      </dt>
      {next && next.boardIndexNumber !== null ? (
        <dd>
          <LinkItem
            to={`${baseUri}/${next.boardIndexNumber}${queryString}`}
            state={{ boardCategoryCode: next.boardCategoryCode }}
          >
            {next.subject}
          </LinkItem>
          <p className="date">
            {/* {dayjs(next.firstRegisterDate).format(`YYYY.MM.DD`)} */}
            {next.firstRegisterDate}
          </p>
        </dd>
      ) : (
        <dd>다음글이 존재하지 않습니다.</dd>
      )}
    </dl>
  </List>
);
export default BoardPrevNext;
